import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import slick from 'slick-carousel';
export default {
  init() {
    console.log('single-campaign');
  },
  finalize() {
    let isFetchingInvitedInfluencers = false;
    let invitedInfluencersNextPage = 1;
    let invitedInfluencersHasMore = true;

    const debounce = (callback, ms) => {
      var timer = 0;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    const fetchInvitedInfluencers = () => {
      isFetchingInvitedInfluencers = true;

      if (!invitedInfluencersHasMore) return;

      $('#invited-influencers > #invited-influencers-loading:last').removeClass('hidden');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.ajax_object.ajaxurl,
        data: { 
            action: 'get_invited_influencers',
            campaign_id: $("#invited-influencers").data("campaign-id"),
            page: invitedInfluencersNextPage,
            nonce: window.ajax_object.nonce,
        },
        success: response => {
          if (response.invited_influencers.length > 0) {
            response.invited_influencers.forEach((influencer) => {
              const influencerRow = 
              '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
                '<a href="' + influencer.profile_url + '" target="_blank" class="w-full flex flex-col">' +
                  '<div>' + influencer.name + '</div>' +
                  '<div>' + influencer.instagram_username + '</div>' +
                  '<div>Följare: ' + influencer.instagram_followers + '</div>' +
                '</a>' +
                '<button type="button" class="delete-invited-influencer cursor-pointer hover:text-white hover:text-grey-medium ml-2" data-influencer-id="' + influencer.id + '" data-influencer-name="' + influencer.name + '">' +
                  '<i class="material-icons block cursor-pointer" style="width: 24px; height: 24px">delete</i>' +
                '</button>' +
              '</li>';

              $('#invited-influencers > #invited-influencers-loading:last').before(influencerRow);
            });
          } else {
            const noInfluencersRow = '<li class="flex hover:bg-grey-light justify-between items-center p-4">Inga inbjudna.</li>';
              $('#invited-influencers > #invited-influencers-loading:last').before(noInfluencersRow);
          }

          $('#invited-influencers > #invited-influencers-loading:last').addClass('hidden');

          invitedInfluencersNextPage++;
          invitedInfluencersHasMore = response.has_more;
          isFetchingInvitedInfluencers = false;
        },
      });
    }

    $(function() {
      fetchInvitedInfluencers();
    });

    $(document).on('click', '#add-invited-influencer', function () {
      const startTypingRow = 
      '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
        'Skriv in ett namn eller e-post i rutan ovan för att söka efter influencers.' +
      '</li>';

      $('#search-influencers-results > #search-influencers-loading:last').before(startTypingRow);

      const body = $(document.querySelector('body'));
      const modal = $("#add-invited-influencer-modal");
      modal.toggleClass('opacity-0');
      modal.toggleClass('pointer-events-none');
      body.toggleClass('modal-active');
    });

    $(document).on('keyup', '#search-influencer-input', debounce(function () {
      $('#search-influencers-results > #search-influencers-loading:last').prevAll().remove();

      if (this.value.length === 0) {
        $('#invited-influencers > #invited-influencers-loading:last').addClass('hidden');

        const startTypingRow = 
        '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
          'Skriv in ett namn eller e-postadress i rutan ovan för att söka efter influencers' +
        '</li>';
  
        $('#search-influencers-results > #search-influencers-loading:last').before(startTypingRow);

      } else {
        $('#search-influencers-results > #search-influencers-loading:last').removeClass('hidden');

        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: window.ajax_object.ajaxurl,
          data: { 
              action: 'search_influencers',
              campaign_id: $("#invited-influencers").data("campaign-id"),
              query: this.value,
              nonce: window.ajax_object.nonce,
          },
          success: response => {
            $('#search-influencers-results > #search-influencers-loading:last').addClass('hidden');

            if (response.influencers.length > 0) {
              response.influencers.forEach((influencer) => {
                const influencerRow = 
                '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
                  '<a href="' + influencer.profile_url + '" target="_blank" class="w-full flex flex-col">' +
                    '<div>' + influencer.name + '</div>' +
                    '<div>' + influencer.instagram_username + '</div>' +
                    '<div>Följare: ' + influencer.instagram_followers + '</div>' +
                  '</a>' +
                  '<button class="invite-influencer-button flex flex-row flex-1 justify-center border-2 text-grey-darkest hover:text-white hover:bg-grey-darkest border-grey-darkest mr-2 p-2 px-4 focus:outline-none" type="button" data-influencer-id="' + influencer.id + '">' +
                    '<span class="invite-influencer-button-text">Bjud&nbsp;in</span>' +
                    '<div class="invite-influencer-spinner flex hidden">' +
                      '<i class="material-icons block cursor-pointer ml-4 animate-spin" style="width: 24px; height: 24px">autorenew_icon</i>' +
                    '</div>' +
                  '</button>' +
                '</li>';
    
                $('#search-influencers-results > #search-influencers-loading:last').before(influencerRow);
              });
            } else {
              const notFoundRow = 
              '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
                'Inga influencers matchade din sökning' +
              '</li>';
        
              $('#search-influencers-results > #search-influencers-loading:last').before(notFoundRow);
            }
          },
        });
      }
    }, 300));

    $(document).on('click', '.invite-influencer-button', function () {
      if ($(this).data('is-inviting-or-invited')) return;
      
      const influencerId = $(this).data('influencer-id');

      $(this).removeClass("cursor-pointer");
      $(this).attr("data-is-inviting-or-invited", true);
      $(this).find(".invite-influencer-button-text").html("Bjuder&nbsp;in");
      $(this).find(".invite-influencer-spinner").removeClass("hidden");

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.ajax_object.ajaxurl,
        data: { 
            action: 'invite_influencer',
            campaign_id: $("#invited-influencers").data("campaign-id"),
            influencer_id: influencerId,
            nonce: window.ajax_object.nonce,
        },
        success: response => {
          if (response.success) {
            const influencerRow = 
            '<li class="flex hover:bg-grey-light justify-between items-center p-4">' +
              $(this).siblings("a").first().prop('outerHTML') +
              '<button type="button" class="delete-invited-influencer cursor-pointer hover:text-white hover:text-grey-medium ml-2" data-influencer-id="' + influencerId + '" data-influencer-name="' + influencerId+ '">' +
                '<i class="material-icons block cursor-pointer" style="width: 24px; height: 24px">delete</i>' +
              '</button>' +
            '</li>';

            $("#invited-influencers").prepend(influencerRow);

            $(this).find(".invite-influencer-button-text").html("Inbjuden");
            $(this).find(".invite-influencer-spinner").addClass("hidden");
          }
        },
      });
    });

    $(document).on('click', '.modal-invite-influencer-close', function () {
      $('#search-influencers-results > #search-influencers-loading:last').prevAll().remove();

      const body = document.querySelector('body');
      const modal = document.querySelector('.modal-invite-influencer');
      modal.classList.toggle('opacity-0');
      modal.classList.toggle('pointer-events-none');
      body.classList.toggle('modal-active');
    });

    $("#invited-influencers").on('scroll', function () {
      const currentPosition = $("#invited-influencers").scrollTop()
      const maxPosition = $("#invited-influencers").prop("scrollHeight")-$("#invited-influencers").height()
      const triggerPosition = maxPosition - 150;

      if (currentPosition >= triggerPosition && !isFetchingInvitedInfluencers) {
        fetchInvitedInfluencers();
      }
    });

    $(document).on('click', '.delete-invited-influencer', function () {
      const influencerId = $(this).data('influencer-id');
      const influencerName = $(this).data('influencer-name');

      $("#delete-influencer").attr('data-influencer-id', influencerId);
      $("#delete-invited-influencer-name").text(influencerName);

      const body = $(document.querySelector('body'));
      const modal = $("#delete-invited-influencer-modal");
      modal.toggleClass('opacity-0');
      modal.toggleClass('pointer-events-none');
      body.toggleClass('modal-active');
    });

    $(document).on('click', '#delete-influencer', function () {
      const influencerId = $('#delete-influencer').data('influencer-id')

      $('#delete_spinner').removeClass("hidden")

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.ajax_object.ajaxurl,
        data: { 
            action: 'delete_invited_influencer',
            campaign_id: $("#invited-influencers").data("campaign-id"),
            influencer_id: influencerId,
            nonce: window.ajax_object.nonce,
        },
        success: response => {
          if (response.success) {
            window.location.reload();
          }
        },
      });
    });

    $('.campaign-slideshow').slick({
      prevArrow: '<button type="button" class="slick-prev transform -translate-y-1/2 absolute top-1/2 left-0 z-10 ml-4"><i class="material-icons align-bottom">navigate_before</i></button>',
      nextArrow: '<button type="button" class="slick-next transform -translate-y-1/2 absolute top-1/2 right-0 z-10 mr-4"><i class="material-icons align-bottom">navigate_next</i></button>',
    });

    $("[name^=screenshot]").on('change', function (e) {
      const preview = $(e.target).siblings('.preview');
      preview.empty();
      const files = e.target.files;

      const readAndPreview = (file) => {
        if (/\.(png|jpe?g)$/i.test(file.name)) {
          const reader = new FileReader();

          reader.addEventListener('load', () => {
            const wrapper = document.createElement('div');
            wrapper.classList.add('w-1/4', 'px-2', 'mb-4');

            const image = document.createElement('div');
            image.classList.add('h-32', 'bg-cover', 'bg-center');
            image.style.backgroundImage = 'url(' + reader.result + ')';

            wrapper.appendChild(image);
            preview.append(wrapper);
          }, false);

          reader.readAsDataURL(file);
        }
      }

      if (files) {
        [].forEach.call(files, readAndPreview);
      }
    });

    $('.material-tab').on('click', e => {
      e.preventDefault();
      $(e.target).parent().addClass('material-tab-active').siblings().removeClass('material-tab-active');
      $('div[data-type="' + $(e.target).data('type') + '"]').show().siblings().hide();
    })
  },
};
